import React from 'react'

import { Card } from 'primereact/card'
import { Message } from 'primereact/message'

import FieldInputText from '../common/FieldInputText'
import FieldInputTextarea from '../common/FieldInputTextarea'
import FieldPassword from '../common/FieldPassword'
import RedactedDetails from '../common/RedactedDetails'

import { STATUS_AWAITING_SUBMIT, STATUS_AWAITING_APPROVAL } from '../../js/const'

import CompanyDetails from '../lobbyist/company-details'

import '../../css/lobbyist-details.css'

const RessponsibleOfficer = ({ isAdd, showAsTextOnly, validationRules }) => {
  return (
    <Card title="Responsible Officer" subTitle="The Responsible Officer is the contact person for any matters relating to the listing on the register.">
      <div className="p-grid">
        <div className="p-col-12">
          <FieldInputText field={"ResponsibleOfficerFirstName"} label={"First Name"} validationRules={validationRules} showAsTextOnly={showAsTextOnly} />
        </div>
        <div className="p-col-12">
          <FieldInputText field={"ResponsibleOfficerLastName"} label={"Last Name"} validationRules={validationRules} showAsTextOnly={showAsTextOnly} />
        </div>
        <div className="p-col-12">
          <FieldInputText field={"ResponsibleOfficerPosition"} label={"Position"} validationRules={validationRules} showAsTextOnly={showAsTextOnly} />
        </div>
        <div className="p-col-12">
          <FieldInputText inputStyle={{ width: 150 }} field={"ResponsibleOfficerPhone"} label={"Phone"} validationRules={validationRules} showAsTextOnly={showAsTextOnly} />
        </div>
        {isAdd && <div className="p-col-12">
          <Message style={{ width: '100%' }} severity="info" text="Email address and password entered will be used to access the register."></Message>
        </div>}
        {isAdd === false && <div className="p-col-12">
          <Message style={{ width: '100%' }} severity="info" text="Changing email address will also change the login username."></Message>
        </div>}
        <div className="p-col-12">
          <FieldInputText field={"ResponsibleOfficerEmail"} label={"Email"} validationRules={validationRules} showAsTextOnly={showAsTextOnly} />
        </div>
        {isAdd && <div className="p-col-12">
          <Message style={{ width: '100%' }} severity="info" text="Password must be at least 8 characters, contain 1 digit, contain 1 uppercase letter and contain 1 lowercase letter."></Message>
        </div>}
        {isAdd &&<div className="p-col-12">
          <FieldPassword inputStyle={{ width: 260 }} field={"NewPassword"} label={"Password"} validationRules={validationRules} />
        </div>}
        {isAdd && <div className="p-col-12">
          <FieldPassword inputStyle={{ width: 260 }} field={"ConfirmPassword"} label={"Confirm Password"} validationRules={validationRules} />
        </div>}
      </div>
    </Card>
  )
}

const OwnerDetails = ({ showAsTextOnly, validationRules, isAuthenticated }) => {
  let subTitle = isAuthenticated ? "Please provide the names of all the owners, partners or major shareholders in your business, including other businesses or individuals. Please note that, where relevant, this information should match the details in your business listing with the Australian Securities and Investments Commission." : ""
  return (
    <Card title="Owner(s)" subTitle={subTitle}>
      <div className="p-grid">
        <div className="p-col-12 p-md-12 p-lg-12">
          <FieldInputTextarea rows={3} field={"OwnerDetails"} label={"Name of Owner(s)"} validationRules={validationRules} showAsTextOnly={showAsTextOnly} />
        </div>
      </div>
    </Card>
  )
}

const ChangesRequired = ({ showAsTextOnly, validationRules }) => {
  return (
    <Card title="Requested Changes">
      <div className="p-grid">
        <div className="p-col-12 p-md-12 p-lg-12">
          <FieldInputTextarea style={{ background: "wheat" }} rows={3} field={"ChangesRequired"} label={"Changes Required"} validationRules={validationRules} showAsTextOnly={showAsTextOnly} />
        </div>
      </div>
    </Card>
  )
}

const LobbyistDetails = ({ currentLobbyist, canSave, canSeePrivateData, isAdmin, isAuthenticated }) => {
  let validationRules = currentLobbyist.ValidationRules ? currentLobbyist.ValidationRules.$values : []

  let isAdd = !currentLobbyist.LobbyistId
  let showAsTextOnly = canSave === false

  let isAwaitingSubmission = currentLobbyist.StatusCode === STATUS_AWAITING_SUBMIT
  let isAwaitingApproval = currentLobbyist.StatusCode === STATUS_AWAITING_APPROVAL

  let previousChangesRequired = currentLobbyist.ChangesRequired
  return (
    <React.Fragment>
      {(isAwaitingSubmission || isAwaitingApproval) && previousChangesRequired && <ChangesRequired isAdd={isAdd} showAsTextOnly={showAsTextOnly} validationRules={validationRules} />}
      <CompanyDetails isAdd={isAdd} showAsTextOnly={showAsTextOnly} validationRules={validationRules} isAuthenticated={isAuthenticated} formName="LobbyistDetails" />
      {canSeePrivateData && <RessponsibleOfficer isAdd={isAdd} showAsTextOnly={showAsTextOnly} validationRules={validationRules}></RessponsibleOfficer>}
      <OwnerDetails showAsTextOnly={showAsTextOnly} validationRules={validationRules} isAuthenticated={isAuthenticated}></OwnerDetails>
      {isAdmin && <RedactedDetails showAsTextOnly={showAsTextOnly} validationRules={validationRules}></RedactedDetails>}
    </React.Fragment>
  )
}

export default LobbyistDetails


// WEBPACK FOOTER //
// ./src/components/lobbyist/lobbyist-details.js